module.exports = __webpack_public_path__ + "static/media/superman.c58206be.jpg";